import { useEffect, useState } from 'react'

import { Section, Text } from '@factorialco/deprecated-design-system'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

import { trackClickSaveResetDay } from 'modules/benefits/lib/trackBenefitsSettings'
import ResetDayUpdateModal from 'modules/benefits/pages/settings/Content/ResetDayUpdateModal'

type Props = {
  companyId: string
  currentResetDay: number
  canEdit: boolean
}

const ResetDaySetting = ({ companyId, currentResetDay, canEdit }: Props) => {
  const [selectedResetDay, setSelectedResetDay] = useState<number>(currentResetDay)
  const [isConfirmOpen, setConfirmOpen] = useState(false)

  useEffect(() => {
    setSelectedResetDay(currentResetDay)
  }, [currentResetDay])

  const options = Array.from({ length: 28 }, (_, i) => ({
    label: i18n.t('benefits.settings.reset_day.day_of_each_month', { day: i + 1 }),
    value: i + 1,
  }))

  const isDirty = selectedResetDay !== currentResetDay

  const performAction = () => {
    trackClickSaveResetDay(currentResetDay, selectedResetDay)
    setConfirmOpen(true)
  }

  return (
    <>
      <Section.Form
        illustration="clock-app"
        title={i18n.t('benefits.settings.reset_day.title')}
        description={i18n.t('benefits.settings.reset_day.description')}
        submitLabel={i18n.t('common.save')}
        isDirty={isDirty}
        onSubmit={performAction}
        disabled={!canEdit}
      >
        <Text.Normal weight="semibold" size="200">
          {i18n.t('benefits.settings.reset_day.date')}
        </Text.Normal>
        <Select
          none="Select"
          value={String(selectedResetDay)}
          onChange={(v) => setSelectedResetDay(Number(v))}
          options={options}
          missingLabel="Missing"
          readonly={!canEdit}
        />
      </Section.Form>

      {isConfirmOpen && (
        <ResetDayUpdateModal
          onClose={() => setConfirmOpen(false)}
          companyId={companyId}
          selectedResetDay={selectedResetDay}
          currentResetDay={currentResetDay}
        />
      )}
    </>
  )
}

export default ResetDaySetting
